import React, { createContext, useState, useContext, useEffect } from 'react';
    import { useTranslation } from 'react-i18next';

    const SettingsContext = createContext(null);

    export const SettingsProvider = ({ children }) => {
        const { i18n } = useTranslation();
        const [language, setLanguage] = useState(localStorage.getItem('crm_language') || i18n.language || 'en');
        const [currency, setCurrency] = useState(localStorage.getItem('crm_currency') || 'INR'); // Default INR

        useEffect(() => {
            const storedLang = localStorage.getItem('crm_language');
            if (storedLang && storedLang !== i18n.language) {
                i18n.changeLanguage(storedLang);
            } else if (!storedLang) {
                localStorage.setItem('crm_language', i18n.language); // Store initial detected language
            }
             // Apply language direction
            document.documentElement.lang = language;
            document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';

        }, [i18n, language]);

        useEffect(() => {
             // Apply language direction on initial load/change
             document.documentElement.lang = language;
             document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
        }, [language])

        useEffect(() => {
            const storedCurrency = localStorage.getItem('crm_currency');
            if (storedCurrency) {
                setCurrency(storedCurrency);
            }
        }, []);

        const changeLanguage = (lng) => {
            i18n.changeLanguage(lng);
            setLanguage(lng);
            localStorage.setItem('crm_language', lng);
            document.documentElement.lang = lng;
            document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
        };

        const changeCurrency = (curr) => {
            setCurrency(curr);
            localStorage.setItem('crm_currency', curr);
        };

        const value = { language, currency, changeLanguage, changeCurrency };

        return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
    };

    export const useSettings = () => useContext(SettingsContext);